"use strict";

function VideoController(
  $rootScope,
  $scope,
  objectMakerFactory,
  dataHolderFactory,
  appSettings,
  $window,
  $http
) {
  $scope.videoViewControl = { showVideo: false };

  $scope.initVideoController = function() {
    configuraVideoClienteOuObrasGov();
    $scope.videoViewControl.analyticsKey = appSettings.getAnalyticsKey();
  };

  /**
   * Configura o video especifico do cliente caso exista, ou o video do ObrasGov por padrao.
   */
  function configuraVideoClienteOuObrasGov() {
    function getVideoObrasGov() {
      $scope.videoViewControl.video = 'videos/EADMapa-obrasgov.mp4';
      $scope.videoViewControl.legenda = 'videos/EADMapa-obrasgov.vtt';
      $scope.videoViewControl.showVideo = true;
    }

    const urlLegenda = `videos/EADMapa-${appSettings.source}.vtt`;
    $http.head(urlLegenda)
      .then(function(response) {
        if (response.status === 200) {
          $scope.videoViewControl.video = urlLegenda.replace('vtt', 'mp4');
          $scope.videoViewControl.legenda = urlLegenda;
          $scope.videoViewControl.showVideo = true;
        } else {
          getVideoObrasGov();
        }
      })
      .catch(function(error) {
        getVideoObrasGov();
      });
  }

  $scope.notifyGoogleAnalytics = function() {
    $window.ga("send", "event", "Videos", "Reproduzido", "Vídeo EAD do mapa", {
      page: "/obras-gov-map/map"
    });
  };
}

VideoController.$inject = [
  "$rootScope",
  "$scope",
  "objectMakerFactory",
  "dataHolderFactory",
  "appSettings",
  "$window",
  '$http'
];
export default VideoController;



// WEBPACK FOOTER //
// ./src/app/scripts/controllers/videoController.js